import React from "react";
import styled from "styled-components";
import PopupLink from "../../PopupLink";

// Util
function createMarkup(str) {
  return { __html: str };
}

// Styled components
const MainHeader = styled.h1`
  font-size: 1.5em;
`;
const Content = styled.div`
  font-size: 0.8em;
`;

// Components
const DynamicFareRulesContent = ({ fareRules }) =>
  Object.keys(fareRules).map(fareRulesKey => (
    <div key={fareRulesKey}>
      <h4> {fareRules[fareRulesKey].title} </h4>
      <Content
        dangerouslySetInnerHTML={createMarkup(fareRules[fareRulesKey].text)}
      />
    </div>
  ));

const PopupContent = ({ fareRules }) => (
  <div>
    <MainHeader> Fare Rules </MainHeader>
    <DynamicFareRulesContent fareRules={fareRules} />
  </div>
);

// Rendered Component
function FullFareRulesLink({ fareRules }) {
  return (
    <PopupLink
      linkText="full fare rules"
      popupContent={<PopupContent fareRules={fareRules} />}
    />
  );
}

export default FullFareRulesLink;



// WEBPACK FOOTER //
// ./src/components/ImportantInformation/FullFareRulesLink/index.js